import { render, staticRenderFns } from "./FooterSidebar.vue?vue&type=template&id=357063d2"
import script from "./FooterSidebar.vue?vue&type=script&lang=js"
export * from "./FooterSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports